import { inject } from "aurelia-framework";
import { Router } from "aurelia-router";
import { HttpClient, Interceptor } from "aurelia-http-client";

@inject(HttpClient, Router)
export default class HttpService {

	private readonly httpClient: HttpClient = null;
	private readonly router: Router = null;
	private authService: any = null;
	private authToken: string = "";
	// private myInterceptors: Interceptor;

	constructor(httpClient: HttpClient, router: Router) {

		this.httpClient = httpClient;
		this.router = router;

		const baseUrl = document.getElementsByTagName("base")[0].href;

		this.httpClient.configure(http => {
			http.withBaseUrl(baseUrl);
			http.withInterceptor(new HttpInterceptors());
		});
	}

	setAuthService(authService: any) {
		this.authService = authService;
	}

	get(url: string, authObject?: any): any {

		const myAuth = this.authService ? this.authService : authObject;
		let myToken = "";
		if (myAuth) {
			myToken = myAuth.getAuthToken();
		}

		const client = this.httpClient
			.createRequest(url)
			.asGet()
			.withHeader("AuthenticationToken", myToken);

		return client;
	}

	post(url: string, postData: any, authObject?: any): any {

		const myAuth = this.authService ? this.authService : authObject;
		let myToken = "";
		if (myAuth) {
			myToken = myAuth.getAuthToken();
		}

		// let self = this;

		const client = this.httpClient
			.createRequest(url)
			.asPost().withContent(postData)
			.withHeader("AuthenticationToken", myToken);

		return client;
	}
}

class HttpInterceptors implements Interceptor {

	responseError(error) {

		if (error.statusCode === 0) {
			throw new Error("Could not contact server");
		}

		if (error.statusCode === 401) {
			// do auth handling here
		}

		if (error.statusCode === 404) {
			// do 404 handling here
		}

		return error;
	}
}
